export default __webpack_public_path__ + "img/Air-offset.dab0b197.png";